import { Injectable } from '@angular/core';
import { FormRegisterableComponent } from '@miq/catalog';

@Injectable({ providedIn: 'root' })
export class ComponentRegistryService {
  private _componentRegistry = new Map<string, FormRegisterableComponent<any>>();

  public set<T = any>(ComponentType: string, ComponentInstance: FormRegisterableComponent<T>): void {
    if (!this._componentRegistry.has(ComponentType)) {
      this._componentRegistry.set(ComponentType, ComponentInstance);
    }
  }

  public delete(ComponentType: string): void {
    if (this._componentRegistry.has(ComponentType)) {
      this._componentRegistry.delete(ComponentType);
    }
  }

  public getColumnComponent(configId: number) {
    return this.getComponent(`columns${configId}`);
  }

  public getSectionComponent(configId: number) {
    return this.getComponent(`sections${configId}`);
  }

  public getGroupSectionComponent(configId: number) {
    return this.getComponent(`groupSection_${configId}`);
  }

  public getComponent<T = any>(fullKey: string): FormRegisterableComponent<T> {
    return this._componentRegistry.get(fullKey);
  }

  public clear() {
    this._componentRegistry.clear();
  }
}
